/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The SourceFolderList model module.
 * @module model/SourceFolderList
 * @version v0
 */
export default class SourceFolderList {
  /**
   * Constructs a new <code>SourceFolderList</code>.
   * @alias module:model/SourceFolderList
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>SourceFolderList</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SourceFolderList} obj Optional instance to populate.
   * @return {module:model/SourceFolderList} The populated <code>SourceFolderList</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SourceFolderList();
      if (data.hasOwnProperty('folderIds'))
        obj.folderIds = ApiClient.convertToType(data['folderIds'], ['String']);
      if (data.hasOwnProperty('uuids'))
        obj.uuids = ApiClient.convertToType(data['uuids'], ['String']);
    }
    return obj;
  }
}

/**
 * @member {Array.<String>} folderIds
 */
SourceFolderList.prototype.folderIds = undefined;

/**
 * @member {Array.<String>} uuids
 */
SourceFolderList.prototype.uuids = undefined;

